import request from "@/plugins/axios"

let prefix = "eids-invoice"

export function list(criteria) {
  return request({
    url: prefix + '/user/pagelist',
    method: 'post',
    data: criteria,
  })
}

export function add(userAddDto) {
  return request({
    url: prefix + '/user/add',
    method: 'post',
    data: userAddDto,
  })
}

export function setEntIds(userDto) {
  return request({
    url: prefix + '/user/entids',
    method: 'post',
    data: userDto,
  })
}

export function update(username, updateParam) {
  return request({
    url: prefix + '/user/update/' + username,
    method: 'post',
    data: updateParam,
  })
}

export function passwordChange(pwdChangeDto) {
  return request({
    url: prefix + '/user/password/change',
    method: 'post',
    data: pwdChangeDto,
  })
}

export function getResetVeriCode(userResetDto) {
  return request({
    url: prefix + '/user/vericode/reset',
    method: 'post',
    data: userResetDto,
  })
}

export function resetPassword(userResetDto) {
  return request({
    url: prefix + '/user/password/reset',
    method: 'post',
    data: userResetDto,
  })
}

export function remove(username) {
  return request({
    url: prefix + '/user/remove/' + username,
    method: 'get',
  })
}

export function deleteUser(id) {
  return request({
    url: prefix + '/user/delete/' + id,
    method: 'get',
  })
}

export function obtainByUsername(username) {
  return request({
    url: prefix + '/user/obtain-by-username/' + username,
    method: 'get',
  })
}

export function register(userRegDto) {
  return request({
    url: prefix + '/user/reg',
    method: 'post',
    data: userRegDto,
  })
}

export function getVeriCode(userRegDto) {
  return request({
    url: prefix + '/user/vericode',
    method: 'post',
    data: userRegDto,
  })
}

